import React, { useCallback, useEffect, useState } from "react";
import styles from "./styles.module.css";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import clsx from "clsx";
import StatusStrip from "../../components/StatusStrip";
import ChancesLeftCard from "../../components/TournamentDetailCards/ChancesLeftCard";
import PrizePoolCard from "../../components/TournamentDetailCards/PrizePoolCard";
import TournamentDetailsCard from "../../components/TournamentDetailCards/TDetailsCard";
import PrizeDistributionCard from "../../components/TournamentDetailCards/PrizeDistributionCard";
import GameRulesCard from "../../components/TournamentDetailCards/GameRulesCard";
import BottomSheetModal from "../../components/BottomSheetModal";
import Accordion from "../../components/Accordion";
import AccordionItem from "../../components/Accordion/AccordionItem";
import { RUPEE_ICON } from "../../appConstants/AppConstant";
import Separator from "../../components/Separator";
import rupeeIcon from "../../assets/rupee-icon.svg";
import { CLEVERTAP_EVENTS } from "../../constant";
import { WidgetItem } from "../../interfaces/TournamentsConfig";
import useQueryParams from "../../hooks/useQueryParams";
import useRegisterTournament from "../../api/useRegisterTournament";
import { StickyBtnBlock } from "./StickyBtnBlock";
import Loader from "../../components/Loader";
import { pushClevertapEvent } from "../../utils/analytics/clevertap";

type TournamentTabProps = {
  tournament: WidgetItem;
  tournamentStatus: string;
  setTournamentCurrentStatus: () => void;
};

const TournamentTab: React.FC<TournamentTabProps> = ({
  tournament,
  tournamentStatus,
  setTournamentCurrentStatus,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isBtnDisabled, setIsBtnDisabled] = useState<boolean>(false);
  const { gameName, ltid } = useQueryParams(["gameName", "ltid"]);
  const data = { gameName: "LUDONX", ltid: Number(ltid) ?? 0 };
  const { registerTournament, loading, isPolling,} =
    useRegisterTournament(data);
  const gamePlayActions = [
    {
      label: t("joinNow"),
      onClick: () => {
        registerTournament(true);
        // navigate(NAVIGATION_ROUTES.GAMEPLAY, { replace: true });
      },
      btnClass: "primaryBtn",
    },
  ];

  const entryDetails = [
    {
      label: t("fromBonus"),
      value: RUPEE_ICON + 0,
    },
    {
      label: t("fromCashback"),
      value: RUPEE_ICON + 0,
    },
    {
      label: t("fromWinningAndDeposits"),
      value: RUPEE_ICON + 0,
    },
  ];
  const entryBreakdown = [
    {
      label: t("toPoolPrize"),
      value: RUPEE_ICON + 7.5,
    },
    {
      label: t("toPlatformFee"),
      value: RUPEE_ICON + 7.5,
    },
  ];

  // Clevertap Event
  const handleClickCTEventForRegisterTournament = useCallback(() => {
    pushClevertapEvent(CLEVERTAP_EVENTS.EVENT_PWA_REGISTER_TOURNAMENT, {
      "location": "tournamentTab",
    });
  }, []);
  
    

  if (isPolling || !tournament) return <Loader transparent/>;
  return (
    <>
      <StatusStrip tournament={tournament} />
      <div className={clsx(styles.tournamentDetailsContainer)}>
        <ChancesLeftCard tournament={tournament} />
        <PrizePoolCard tournament={tournament} />
        <TournamentDetailsCard tournament={tournament} />
        <PrizeDistributionCard tournament={tournament} />
        <GameRulesCard tournament={tournament} />
        <StickyBtnBlock
          onClick={() => {
            // setModalOpen(true);
            registerTournament(true);
            handleClickCTEventForRegisterTournament();
            setIsBtnDisabled(true);
          }}
          disabled={isBtnDisabled}
          btnName={t("playNow")}
          tournamentStatus={tournamentStatus}
          setTournamentCurrentStatus={setTournamentCurrentStatus}
          tournament={tournament}
        />

        {/* <BottomSheetModal
          isOpen={isModalOpen}
          modalIcon={rupeeIcon}
          title={t("confirmPayment")}
          content={
            <div className={clsx(styles.gameDetailsBox)}>
              <Accordion>
                <AccordionItem
                  title={
                    <div
                      className={clsx(
                        styles.entryBoxheading,
                        "fontSizeSm fontWeightMedium fontColorBlack"
                      )}
                    >
                      <span>{t("entryFee")}</span>
                      <span>{RUPEE_ICON + 10}</span>
                    </div>
                  }
                  backgroundColor="gray"
                  accordionInnerContentClassName={clsx(
                    styles.accordionInnerContent
                  )}
                >
                  <div className={clsx(styles.entryDetailingbox)}>
                    {entryDetails.map(({ label, value }, index) => (
                      <div
                        className={clsx(
                          styles.rowItem,
                          "fontColor666 fontWeightMedium fontSizeSm14"
                        )}
                        key={index}
                      >
                        <div className={clsx(styles.colItem)}>{label}</div>
                        <div className={clsx(styles.colItem)}>{value}</div>
                      </div>
                    ))}
                    <Separator />
                    <label
                      className={clsx(
                        styles.entryBreakdownLabel,
                        "fontColor333 fontWeightMedium fontSizeSm14 textAlignLeft"
                      )}
                    >
                      {t("entryFeeBreakdown")}:
                    </label>
                    {entryBreakdown.map(({ label, value }, index) => (
                      <div
                        className={clsx(
                          styles.rowItem,
                          "fontColor666 fontWeightMedium fontSizeSm14"
                        )}
                        key={index}
                      >
                        <div className={clsx(styles.colItem)}>{label}</div>
                        <div className={clsx(styles.colItem)}>{value}</div>
                      </div>
                    ))}
                  </div>
                </AccordionItem>
              </Accordion>
            </div>
          }
          actions={gamePlayActions}
          onClose={() => setModalOpen(false)}
        /> */}
      </div>
    </>
  );
};
export default TournamentTab;
